export default "__VITE_ASSET__a8f15a05__"